import React, { ReactElement } from 'react';

import { Label, Toggle, StyledTickIcon } from './styles';

type Props = {
  className?: string;
  name?: string;
  id?: string;
  onChange?: (checked: boolean) => void;
  checked?: boolean;
  label?: string | ReactElement;
  height?: number;
  width?: number;
  iconHeight?: number;
  iconWidth?: number;
};

// Sorry for the dimension props, at somepoint it would be worthwhile to switch this out with a component that can be resized
// more easily, or figure out how to make this one dynamcally resize with just the height/width being set.
const ToggleCheckbox = ({
  name,
  id = name,
  onChange,
  checked,
  label,
  className,
  height = 29,
  width = 54,
  iconHeight = 24,
  iconWidth = 24,
}: Props) => (
  <Label htmlFor={name} className={className}>
    <input type="checkbox" name={name} id={id} onChange={e => onChange(e.target.checked)} checked={checked} />
    <Toggle checked={checked} height={height} width={width}>
      <StyledTickIcon checked={checked} height={height} iconHeight={iconHeight} iconWidth={iconWidth} />
    </Toggle>
    {label}
  </Label>
);

export default ToggleCheckbox;
